/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React context
import { useSoftUIController, setLayout } from "context";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <SoftBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        px: "2px",
        position: "relative",

        "& > .MuiAppBar-root ~ .MuiBox-root:first-of-type": {
          paddingTop: "2px !important",
          paddingLeft: "0 !important",
          paddingRight: "0 !important",
          marginTop: "-14px !important",
        },

        "& .MuiTypography-h4, & .MuiTypography-h5": {
          fontSize: "0.875rem !important",
          lineHeight: "1.5 !important",
        },

        "& .MuiCard-root > .MuiBox-root:has(> .MuiTabs-root)": {
          paddingTop: "2px !important",
          paddingLeft: "2px !important",
          paddingRight: "2px !important",
        },

        '& .MuiCard-root > .MuiBox-root:has(input[placeholder*="search" i])': {
          paddingTop: "2px !important",
          paddingBottom: "4px !important",
          paddingLeft: "2px !important",
          paddingRight: "2px !important",
          fontSize: "12px !important",
          fontWeight: "400 !important",
        },

        '& .MuiBox-root:not([data-full-size-search="true"]):has(> .MuiInputBase-root > input[placeholder*="search" i])': {
          width: "9rem !important",
          maxWidth: "9rem !important",
        },

        '& .MuiInputBase-root:not([data-full-size-search="true"]):has(input[placeholder*="search" i])': {
          minHeight: "24px !important",
          padding: "1px 8px !important",
        },

        '& .MuiInputBase-root:not([data-full-size-search="true"]):has(input[placeholder*="search" i]) input': {
          height: "20px !important",
          fontSize: "10px !important",
        },

        [breakpoints.up("xl")]: {
          marginLeft: miniSidenav ? pxToRem(112) : pxToRem(191),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </SoftBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
